import React from "react";
import { Tooltip } from "react-tooltip";
import { WorldMap } from "../ui/WorldMap";

export const WorldMapContainer = () => {
  const [content, setContent] = React.useState<React.ReactNode>();
  const [style, setStyle] = React.useState<React.CSSProperties>({});

  return (
    <div>
      <WorldMap setTooltipContent={setContent} setTooltipStyle={setStyle} />
      <Tooltip
        id="my-tooltip"
        style={style}
        className="opaque tooltip"
        classNameArrow="tooltipArrow"
      >
        {content}
      </Tooltip>
    </div>
  );
};
